import { ActionReducerMapBuilder, PayloadAction } from "@reduxjs/toolkit";
import {
  DepositFormSettingResponseType,
  MemberOrderResponseType,
} from "api/deposit/type";
import { NoInfer } from "react-redux";
import {
  DepositStateType,
  WithDrawalFormSettingTypeResponse,
} from "types/deposit";

import {
  getDepositForm,
  getMemberOrders,
  getWithdrawalForm,
} from "./deposit.thunk";

export const extraReducers = (
  builder: ActionReducerMapBuilder<NoInfer<DepositStateType>>
) => {
  builder
    .addCase(getDepositForm.pending, (state: DepositStateType) => {
      return {
        ...state,
        isLoadingDeposit: true,
      };
    })
    .addCase(
      getDepositForm.fulfilled,
      (
        state: DepositStateType,
        action: PayloadAction<DepositFormSettingResponseType>
      ) => {
        action.payload.data.setting.min_deposit = Number(
          action.payload.data.setting.min_deposit
        );
        action.payload.data.setting.max_deposit = Number(
          action.payload.data.setting.max_deposit
        );
        return {
          ...state,
          isLoadingDeposit: false,
          dataDeposit: action.payload.data,
        };
      }
    );

  builder
    .addCase(getMemberOrders.pending, (state: DepositStateType) => {
      state.isLoading = true;
    })
    .addCase(
      getMemberOrders.fulfilled,
      (
        state: DepositStateType,
        action: PayloadAction<MemberOrderResponseType>
      ) => {
        state.isLoading = false;
        state.dataMemberOrder = { ...action.payload };
      }
    );

  builder
    .addCase(getWithdrawalForm.pending, (state: DepositStateType) => {
      state.isLoading = true;
    })
    .addCase(
      getWithdrawalForm.fulfilled,
      (
        state: DepositStateType,
        action: PayloadAction<WithDrawalFormSettingTypeResponse>
      ) => {
        return {
          ...state,
          isLoading: false,
          dataWithdrawal: action.payload.data,
        };
      }
    );
};
